import { render, staticRenderFns } from "./LabelText.vue?vue&type=template&id=0a7a40b5&scoped=true&"
import script from "./LabelText.vue?vue&type=script&lang=js&"
export * from "./LabelText.vue?vue&type=script&lang=js&"
import style0 from "./LabelText.vue?vue&type=style&index=0&id=0a7a40b5&lang=scss&scoped=true&"
import style1 from "./LabelText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a40b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VSheet,VTextField})
